

class ImageCompareTabs extends HTMLElement {
  constructor () {
    super()
    
    this.tabs = this.querySelectorAll('.image-compare-tabs__tab');
    this.tabsButton = this.querySelectorAll('.image-compare-tabs__button');
    Array.from(this.tabsButton).forEach(function(btn){
        btn.addEventListener('click', this.switchTab.bind(this));
    }, this);

  }
  switchTab(e) {
    e.preventDefault();
    let tab_index = e.target.dataset.index;
    Array.from(this.tabsButton).forEach(function(btn){
        if(btn.dataset.index != tab_index) {
            btn.classList.remove('active');
        }else {
            btn.classList.add('active');
        }
    }, this);

    Array.from(this.tabs).forEach(function(tab){
        if(tab.dataset.index != tab_index) {
            tab.classList.remove('active');
        }else {
            tab.classList.add('active');
        }
    }, this);
  }
}

customElements.define('image-compare-tabs', ImageCompareTabs)
